var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6251 4.05229L15.9735 0.375521C15.7322 0.135013 15.4057 0 15.0653 0C14.7249 0 14.3983 0.135013 14.157 0.375521L1.21153 13.3252L0.0295781 18.4353C-0.0111954 18.6221 -0.00979762 18.8157 0.0336691 19.0019C0.0771358 19.188 0.161574 19.3622 0.280814 19.5115C0.400054 19.6608 0.551085 19.7815 0.722873 19.8649C0.894661 19.9482 1.08287 19.9921 1.27374 19.9933C1.36268 20.0022 1.4523 20.0022 1.54124 19.9933L6.69829 18.8092L19.6251 5.87197C19.8652 5.63025 20 5.30312 20 4.96213C20 4.62114 19.8652 4.29402 19.6251 4.05229ZM6.07621 17.6875L1.24264 18.7033L2.34372 13.9546L12.0295 4.2891L15.762 8.02818L6.07621 17.6875ZM16.5956 7.12457L12.8631 3.38548L15.028 1.22928L18.6982 4.96836L16.5956 7.12457Z",
    fill: "#38AEC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.d7e178d46e94f9aa5bcc4ec7ba5e1245.svg";
export { ForwardRef as ReactComponent };